export class InsuranceCarrierModel {
  insuranceCarriers?: [];

  constructor() {
    this.insuranceCarriers = [];
  }
}
